<a href="javascript: void(0)"
    (click)="onItemClick(dataItem)">
    {{dataItem[property]}}
</a>